import { createStore } from 'vuex'
import VuexPersist from 'vuex-persist'
import API from './api/myco'
import { companySettings } from './utils/companySettings'
import { setDocumentTitle } from './utils/documentTitle'

const vuexSessionStorage = new VuexPersist({
  key: 'vuex',
  storage: window.sessionStorage,
  reducer: (state) => ({ user: state.user, company: state.company }),
})

export default createStore({
  plugins: [vuexSessionStorage.plugin],
  state: {
    user: null,
    company: null,
    themePreviewColor: null,
    navCollapsed: false,
    navMobileOpen: false,
    snackbarIsOpen: false,
    snackbarColor: 'success',
    snackbarText: '',
    notifications: [],
    reminders: [],
  },
  getters: {
    user: (state) => state.user,
    isAdmin: (state) => !!state.user?.isAdmin,
    isSuperAdmin: (state) => !!state.user?.isSuperAdmin,
    themeColor: (state) => state.themePreviewColor || companySettings(state.company).themeColor,
    companySettings: (state) => companySettings(state.company),
    navWidth: (state) => (state.navCollapsed ? 72 : 200),
  },
  mutations: {
    setUser(state, user) {
      state.user = user
      if (!user) {
        state.company = null
        state.notifications = []
        state.reminders = []
        setDocumentTitle('')
      }
    },
    setNotifications(state, items) {
      state.notifications = items || []
    },
    setReminders(state, items) {
      state.reminders = items || []
    },
    setCompany(state, company) {
      state.company = company
      setDocumentTitle(company?.name)
    },
    setThemePreviewColor(state, color) {
      state.themePreviewColor = color || null
    },
    clearThemePreviewColor(state) {
      state.themePreviewColor = null
    },
    setNavCollapsed(state, value) {
      state.navCollapsed = value
    },
    toggleNavCollapsed(state) {
      state.navCollapsed = !state.navCollapsed
    },
    setNavMobileOpen(state, value) {
      state.navMobileOpen = value
    },
    toggleNavMobileOpen(state) {
      state.navMobileOpen = !state.navMobileOpen
    },
    setSnackbar(state, snackbarProps) {
      state.snackbarColor = snackbarProps.type
      state.snackbarText = snackbarProps.message
      state.snackbarIsOpen = true
    },
    closeSnackbar(state) {
      state.snackbarIsOpen = false
    },
  },
  actions: {
    async clearTenantCaches({ commit }) {
      commit('setNotifications', [])
      commit('setReminders', [])
      commit('clearThemePreviewColor')
    },
    async refreshNotifications({ commit, state }) {
      if (!state.user) {
        commit('setNotifications', [])
        commit('setReminders', [])
        return { notifications: [], reminders: [] }
      }
      const [{ data: notifications }, { data: reminders }] = await Promise.all([
        API.notification.list({ type: 'notifications', limit: 20, offset: 0 }),
        API.notification.list({ type: 'reminders', limit: 20, offset: 0 }),
      ])
      const notificationItems = notifications?.items || []
      const reminderItems = reminders?.items || []
      commit('setNotifications', notificationItems)
      commit('setReminders', reminderItems)
      return { notifications: notificationItems, reminders: reminderItems }
    },
  },
})
